<p-button
  [disabled]="disabled"
  [size]="sizeClass"
  [severity]="primeButtonStyle.severity"
  [variant]="primeButtonStyle.variant"
  (onClick)="buttonClicked()"
  [styleClass]="styleClass"
>
  <shared-ui-icons-icon *ngIf="!showSpinner && icon" [iconName]="icon" [tooltip]="iconTooltip"></shared-ui-icons-icon>
  <span *ngIf="text">{{ text }}</span>
  <span *ngIf="showSpinner" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  <shared-ui-badges-badge *ngIf="badgeText && badgeType" [type]="badgeType" [text]="badgeText"></shared-ui-badges-badge>
  <span *ngIf="textAfterBadge">{{ textAfterBadge }}</span>
</p-button>
